import { createAction } from "@redux/actions/actionCreators";

const [useSetProductAssignedMarkets, setProductAssignedMarkets] = createAction<{
  productUuid: string;
  assignedMarketUuids: string[];
}>("product/setAssignedMarkets");

export default useSetProductAssignedMarkets;
export { setProductAssignedMarkets };
